// removed by extract-text-webpack-plugin
module.exports = {"categoryHeader":"categoryHeader--1cb99"};